import { Link } from "react-router-dom";
import React from 'react';

export const columnDefs = [
  { 
    headerName: 'Role ID#',
    field: 'role_id',
    minWidth: 110,
    headerCheckboxSelection: true,
    checkboxSelection: true
  },
  { 
    headerName: 'Role name',
    field: 'role_name',
    minWidth: 200,
    cellRenderer: (params) => {
      return <Link to={`/authorization/roles/${params.data.role_id}`} target="_blank">{params.value}</Link>
    }
  },
  { 
    headerName: 'User name',
    field: 'user_name',
    minWidth: 90,
    cellRenderer: (params) => {
      return <Link to={`/authorization/users/${params.data.user_id}`} target="_blank">{params.value}</Link>
    }
  },
  { 
    headerName: 'Full of name',
    field: 'full_name',
    minWidth: 140
  },
  { 
    headerName: 'Sales unit',
    field: 'sales_unit_description',
    minWidth: 120
  },
  { 
    headerName: 'Permission no.',
    field: 'permission_id',
    minWidth: 100
  },
  { 
    headerName: 'Subject_class',
    field: 'subject_class',
    minWidth: 150
  },
  { 
    headerName: 'Action',
    field: 'action',
    minWidth: 100
  },
  { 
    headerName: 'Description',
    field: 'description',
    minWidth: 200
  },
  { 
    headerName: 'Module',
    field: 'parent_group',
    minWidth: 100,
  }
];